module.exports = __webpack_public_path__ + "img/Cover_HW_23.87c3ce8e.jpg";